module.exports = __webpack_public_path__ + "img/processing-04.78b519ae.gif";